import { render, staticRenderFns } from "./UserGlobalCommentModal.vue?vue&type=template&id=0e0627f8&scoped=true"
import script from "./UserGlobalCommentModal.vue?vue&type=script&lang=js"
export * from "./UserGlobalCommentModal.vue?vue&type=script&lang=js"
import style0 from "./UserGlobalCommentModal.vue?vue&type=style&index=0&id=0e0627f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0627f8",
  null
  
)

export default component.exports